import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-products-images-view',
  templateUrl: './products-images-view.component.html',
  styleUrls: ['./products-images-view.component.scss']
})
export class ProductsImagesViewComponent implements OnInit {

  public imageSrc;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
